import React, { Component } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import { ControlWrapperExtended as ControlWrapper } from './../ControlWrapper/ControlWrapper'
import TextIcon from './TextIconSvg'

const styles = {
  input: {
    height: 40,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 2,
    border: '1px solid #dee1e5',
    backgroundColor: 'white',
    width: 358,
    boxSizing: 'border-box',
    color: '#858585',
    appearance: 'none',
  },
}

class TextControl extends Component {

  state = {
    value: this.props.placeholder
  }

  updatePlaceholder = (e) => {
    const { onUpdate } = this.props
    var value = e.target.value
    onUpdate({
      placeholder: value,
    })
  }

  onChange = (e) => this.setState({ value: e.target.value });

  render = () => {
    const {
      placeholder,
      classes,
      disabled,
      type,
      style,
      ...otherProps } = this.props
    const { value } = this.state

    return <ControlWrapper
      icon={<TextIcon />}
      {...otherProps}
    >
      <input
        type={type}
        disabled={disabled}
        value={value}
        onChange={this.onChange}
        onBlur={this.updatePlaceholder}
        className={classes.input}
        style={style}
      />
    </ControlWrapper>
  }
}

export default injectStyles(styles)(TextControl)



// WEBPACK FOOTER //
// ./src/modules/TextControl/TextControl.js